import React, { Component } from "react";
import { Container } from "@amzn/awsui-components-react";
import { HopCard } from "./HopCard";
import TrailblazerStackData from "../data/TrailblazerStackData";

export default class TrailblazerStack extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stackDataManager: null
        };
    }

    componentDidMount() {
        this.processRouteData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.route !== this.props.route) {
            this.processRouteData();
        }
    }

    processRouteData() {
        if (!this.props.route || !this.props.route.hops) {
            this.setState({ stackDataManager: null });
            return;
        }

        this.setState({
            stackDataManager: new TrailblazerStackData(this.props.route)
        });
    }

    /**
     * Renders the header displaying the route metadata.
     */
    renderHeader = () => {
        const { stackDataManager } = this.state;

        if (!stackDataManager || !stackDataManager.hasMetadata()) {
            return (
                <Container>
                    Missing metadata for route.
                </Container>
            );
        }

        // iterates and renders all the metadata elements
        const metadataEntries = stackDataManager.getRenderableMetadata().map(({
            key, displayName, renderedValue
        }) => (
            <p key={key}>
                <strong>{displayName}:</strong> {renderedValue}
            </p>
        ));

        return (
            <Container>
                <h3>Route Information</h3>
                <div>
                    {metadataEntries}
                </div>
            </Container>
        );
    }

    renderHopStack = () => {
        const { stackDataManager } = this.state;

        if (!stackDataManager || !stackDataManager.hasValidRoute()) {
            return (
                <Container>
                    <h3>Hop Details</h3>
                    <div>No hops in this route</div>
                </Container>
            );
        }

        const renderableHops = stackDataManager.getRenderableHops();

        return (
            <Container>
                <h3>Hop Details</h3>
                {renderableHops.map(hop => <HopCard key={hop.name} renderableHop={hop}/>)}
            </Container>
        );
    }

    render() {
        const { route } = this.props;

        if (!route) {
            return (
                <Container>
                    <div>No route data available</div>
                </Container>
            );
        }

        return (
            <div>
                {this.renderHeader()}
                {this.renderHopStack()}
            </div>
        );
    }
}